<template>
<main>
    <div class="image-group">
      <div class="image">
        <img src="../assets/img/neuro/group1/photo3.png" alt="">
      </div>   

      <div class="image">
        <img src="../assets/img/neuro/group1/photo2.png" alt="">
      </div>

      <div class="image">
        <img src="../assets/img/neuro/group1/photo4.png" alt="">
      </div>

      <div class="image">
        <img src="../assets/img/neuro/group1/photo1.png" alt="">
      </div>
    </div>
    <section>
      <div class="green-outline">
      <div class="flex-group">
        <div>
          <img src="../assets/img/neuro/neuro-title.png" alt="" width="300" height="300">
        </div>

        <div class="text">
            <h2 class="green-text">Besser Reiten <br />mit Neuro-Athletik Training</h2>
            <p>Kurz gesagt wird beim Neuro-Training das Gehirn trainiert. 
              Durch die Förderung von intuitiven Abläufen erfolgt eine schnellere und präzisere Reaktion.</p>
        </div>
      </div>
      </div>
    </section>

    
   <section>
    <div class="darkgreen-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h3>Was ist Neuro-Athletik Training?</h3>
              <p>Das Gehirn und das Nervensystem werden im Neuro-Athletik Training als zentrale Elemente 
                der Bewegungssteuerung miteinbezogen. Denn diese sind maßgeblich an der Steuerung unsere Muskeln und Faszien beteiligt.</p>
            </div>
            <div>
              <img src="../assets/img/neuro/balance-stange.png" alt="">
            </div>
          <!-- </div> -->
        </div>
    </div>

    <div class="green-box">
     <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div>
            <img src="../assets/img/neuro/brock-pferd.png" alt="">
          </div>
        
          <div class="text">
            <p>Dabei gibt es fünf Kernbereiche, welche auf Dr. Eric Cobb zurückgehen, der neurowissenschaftliche 
              Erkenntnisse in bestehende biomechanische Modelle integriert hat:</p>
            <ul>
              <li>Veränderung der Körperstrukturen</li>
              <li>Entlastung von Schmerz</li>
              <li>Leistungsverbesserung</li>
              <li>Prävention von Verletzungen</li>
              <li>Motivierung und Änderung von Gewohnheiten</li>
            </ul>
          </div>
        </div>
      </div>
    </section>



    <section id="termine">
    <div class="grey-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h3>Termine</h3>
              <span class="btn-green">
                <router-link :to="{ path: '/termine' }" class="link">aktuelle Termine</router-link>
              </span>
              <!-- <p>
                Je nachdem welchen Schwerpunkt du setzen möchtest, gibt es folgenden Angebote für dich:
              </p> -->
              <!-- <ul>
                <li> -->
                  <!-- <ul> -->
                    <!-- <li>
                        <p><b>05.11.2022 in St. Leonhard am Forst/NÖ</b></p>
                        <a href="https://fb.me/e/2hkkFS7hA">Infos und Anmeldung</a>
                    </li>
                    <li>
                        <p><b>25.11.2022 in Steinbrunn/Burgenland</b></p>
                        <a href="https://fb.me/e/3y51YcTYU">Infos und Anmeldung</a>
                    </li> -->
                    <!-- <li>
                        <p><b>16.12.2022 in St. Leonhard am Forst/NÖ</b></p>
                        <a href="https://fb.me/e/2b8CG1lwj">Infos und Anmeldung</a>
                    </li>
                    <li>
                        <p><b>21.01.2022 in Wiener Neustadt/NÖ</b></p>
                        <a href="https://fb.me/e/2Ase8wiYp">Infos und Anmeldung</a>
                    </li> -->
                     <!-- <li>
                        <h4>Schnuppernachmittag am 10.03.2022 in Neunkirchen/NÖ 15:00-19:00</h4>
                        <a href="https://fb.me/e/32MbBHVEj">Infos und Anmeldung</a>
                    </li>
                  </ul> -->
                  
                <!-- </li> -->
                <!-- <li><h4>Kursreihe: Koordination & Balance</h4>
                  <ul>
                    <li>
                        <p><b>4-wöchigen Kursreihe: Start am 10.11.2022 in St. Leonhard am Forst/NÖ</b></p>
                        <a href="https://fb.me/e/329gksvNm">Infos und Anmeldung</a>  
                    </li>
                  </ul>

                </li>
                <li><h4>Gesunder Hufbearbeiter durch Neuro-Athletik Training</h4>
                  <ul>
                    <li>
                        <p>08.12.2022 in St. Leonhard am Forst/NÖ</p>
                        <a href="https://fb.me/e/2jukduR4j">Infos und Anmeldung</a> 
                    </li>

                  </ul>
 
                </li>
                <li><h4>Angstfrei reiten</h4>
                  <p>Termine in Planung</p>
                </li>
                <li><h4>Wiedereinstieg nach Pause oder Verletzung</h4>
                    <p>Termine in Planung</p>
                </li>-->
                <!-- <li> -->
                  <!-- <h4>Organisiere deinen Kurs</h4>
                    <router-link :to="{ path: 'neuro#einzeltraining' }" class="desktop link">mehr Infos</router-link> -->
                <!-- </li>  -->
              <!-- </ul> -->
            </div>

        </div>
      </div>
    </section>


    <section>
      <div class="green-box">
      <div class="flex-group">
        <!-- <div class="content-container"> -->

          <div class="text">
            <h3>Wie läuft das ab?</h3>
            <p>
            Im Neuro-Athletik Training arbeiten wir mit dem Test-Retest- Verfahren. 
            Das bedeutet, dass ein körperlicher Test durchgeführt wird, dann eine spezifische Übung und im Anschluss derselbe Test. 
            Dadurch kann ein Vergleich angestellt werden, ob diese Übung für den Körper hilfreich ist oder nicht.
            </p>
            <p>
            So entsteht ein individueller Trainingsplan aus Übungen, welche zu einer Verbesserung von deinem Gehirn und Nervensystem 
            und damit deinem Körpers führen. Um langfristig davon zu profitieren sind Wiederholungen der Übungen notwendig.
            </p>
          </div>

          <div>
            <img src="../assets/img/neuro/retest.png" alt="">
          </div>
        </div>
      </div>


      <div class="darkgreen-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->

            <div>
              <img src="../assets/img/neuro/nacken.png" alt="">
            </div>
            <div class="text">
              <h3>
                Effizientes Training
              </h3>
              <p>Das Training ist sehr effizient - du trainierst das, was dich besser macht!<p />
              <p>Die meisten Übungen können in kurzer Zeit und ohne viel Anstrengung absolviert werden.
                  Dein Sitz und deine Einwirkung am Pferd werden weniger Kraft brauchen, da die unbewusste 
                  Muskelansteuerung verbessert wird. Deine Koordination wird genauer und deine Reaktionen schneller werden. 
                  Dadurch wird indirekt auch das Verletzungsrisiko geringer. Deine Bewegungsabläufe werden gezielter abrufbar und leichter reproduzierbar.</p>
              <p>Und das alles, weil du durch konkrete Übungen die Vernetzung der Nervenbahnen mit dem Gehirn optimierst.</p>

            </div>
          <!-- </div> -->
        </div>
      </div>
      </section>



      <section class="grey-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h3>Warum funktioniert das?</h3>
              <p>
                Das Gehirn ist neuroplastisch, daher bereit seine Funktion an die gestellten Anforderungen anzupassen. 
                Je besser die Wahrnehmung und Ansteuerung deines Körpers, dein Sehvermögen, deine Atmung und dein Gleichgewichtssystem funktionieren, 
                desto mehr Kapazitäten sind für das frei was du tun möchtest - zum Beispiel Reiten.
                </p>
            </div>
            <div>
              <img src="../assets/img/neuro/rhomberg-stand.png" alt="">
            <!-- </div> -->
          </div>
        </div>
    </section>

    <section class="green-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h3>Wie verbessert das mein Reiten?</h3>
              <p>Durch die Verbesserung von intuitiven Bewegungsabläufen wird dein Sitz ruhiger und stabiler. Du kannst konkrete Entscheidungen 
                über das Timing und die Intensität der Hilfen treffen und diese präzise ausführen. Wir erreichen also:
              </p>
              <ul>
                <li>einen ausbalancierten, mitgehenden Sitz</li>
                <li>gut koordinierte, feine Hilfen</li>
                <li>schnellere Reaktionen und höhere Sicherheit</li>
              </ul>
            </div>

            <div>
              <img src="../assets/img/neuro/vision-stick-pferd.png" alt="">
            <!-- </div> -->
          </div>
        </div>
    </section>

    <section class="darkgreen-box">
      <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div class="text">
            <h3>So macht lernen Spaß</h3>
            <p>
              Neue Bewegungen auszuführen und sich selbst vor kleine Herausforderungen zu stellen macht Spaß. Die Übungen werden zum Teil am Pferd, 
              zum Teil am Boden ausgeführt.</p>

            <p>Durch die hohe Variation in der Ausführung einzelner Übungen werden solide Nervenbahnen geschaffen und die Idee 
              des „Fehlers“ relativiert. Fehler bzw. Abweichungen werden als Gelegenheit zum Lernen gesehen. Je mehr Varianten 
              ausprobiert werden, umso mehr Information bekommt dein Gehirn. Dasselbe gilt für dein Pferd.</p>
          </div>
      
            <div>
              <img src="../assets/img/neuro/slalom.png" alt="">
          </div>
      </div>
    </section>
    


    <section class="grey-box" id="einzeltraining">
      <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div class="text">
            <h2>Individuelle Einzel-Einheiten</h2>
            <p>Einzel-Einheiten sind mit und ohne Pferd, vor Ort oder online möglich. Um online-Termine bestmöglich zu nutzen,
              empfiehlt es sich bereits mit der Methode vertraut zu sein. Das kann zum Beispiel durch die Teilnahme an einem 
              Schnuppernachmittag, oder jedem anderen Kursformat erfolgen.</p>

            <p>Bei einer Einzel-Einheit fokussieren wir uns ganz auf dich und deine individuellen Themen.</p>
            <p>Infos und Anmeldung per Email an <br><span class="btn-red"><a href="mailto:info@pferdeverstand.at">info@pferdeverstand.at</a></span></p>
          </div>
      
          <div>
            <img src="../assets/img/neuro/handgelenk.png" alt="">
          </div>
        <!-- </div> -->
      </div>
    </section>

    <section class="darkgreen-box">
      <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div class="text">
            <h2>Ein Kurs in deinem Stall?!</h2>
            <p>Wenn du gerne einen Kurs mit mir bei dir im Stall organisieren möchtest, schreib mir einfach eine<br> <span class="btn-red"><a href="mailto:info@pferdeverstand.at">E-mail</a></span></p>
            <p>Wir finden zusammen Möglichkeiten!</p>
          </div>
      
          <div class="logo-block">
            <img src="../assets/img/home/logo-short.png" alt="">
            <p class="invert">... für alle, die mit ihrem Pferd weiterkommen wollen.</p>
          </div>
        <!-- </div> -->
      </div>
    </section>

    <div class="image-group">
      <div class="image">
        <img src="../assets/img/neuro/group2/photo1.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/neuro/group2/photo3.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/neuro/group2/photo2.png" alt="">
      </div>

      <div class="image">
        <img src="../assets/img/neuro/group2/photo4.png" alt="">
      </div>
    </div>
  </main>

</template>

<script>
export default {
  name: "Neuro", //this is the name of the component
  
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
  metaInfo() {
      return { 
          title: "Neuro-Athletik Training für Reiter",
          meta: [
            { name: 'description', content: 'Besser reiten mit Neuro-Athletik Training' },
            { property: 'og:title', content: "Besser reiten mit Neuro-Athletik Training"},
            { property: 'og:description', content: 'Beim Neuro-Training wird das Gehirn trainiert. Durch die Förderung von intuitiven Abläufen erfolgt eine schnellere und präzisere Reaktion, die dir vor allem am Pferd zugute kommen.'}, 
            { property: 'og:image', content: '../assets/img/neuro/brock-pferd.png'},
            { property: 'og:url', content: 'www.pferdeverstand.at/neuro'}

          ]
      }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Neuro.vue